var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0}),React.createElement("g",{"id":"icomoon-ignore","key":1}),React.createElement("path",{"d":"M1020.629 847.476h-944.613c-0.142 0.002-0.305 0.003-0.472 0.003-31.833 0-57.623-25.8-57.623-57.623 0-14.788 5.569-28.275 14.723-38.48l471.004-538.65c10.517-11.041 25.341-17.919 41.754-17.919s31.237 6.874 41.742 17.888l475.248 538.725c9.118 10.146 14.686 23.638 14.686 38.435 0 31.413-25.133 56.958-56.39 57.618z","key":2})]);
}

ArrowUp.displayName = "ArrowUp";

ArrowUp.defaultProps = {"version":"1.1","width":"1095","height":"1024","viewBox":"0 0 1095 1024"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
